export default "__VITE_ASSET__BDgiscv0__"